// Copied into your app by RapidRailsUI (bin/rails rui:update).
// Don't edit this copy: the next update overwrites it. Fix it in the rapid_rails_ui gem.
//
// Timeline readout maths, no DOM. Mirrors Chart::Component#readout_total and
// #readout_value_at, and test/javascript/chart_readout.test.mjs checks the same
// cases the Ruby tests assert, so the count-up lands on the server's number.
//
// lookup(c, s) returns the series' value at category c, or null when the series
// has no point there (a line's gap, or the projection's category).

// :value at a category the series has no point for: the projection value when the
// projection starts from that series (series 0), else the series' last real point
// before it. Never 0 for "no point" (0.74.1).
export function valueAtStep(lookup, k, s, projection = null) {
  const own = lookup(k, s)
  if (own !== null && own !== undefined) return own
  if (projection && s === 0 && projection.category === k) return projection.value
  for (let c = k - 1; c >= 0; c--) {
    const v = lookup(c, s)
    if (v !== null && v !== undefined) return v
  }
  return 0
}

// Total at step k for the picked series indexes by mode: "value" shows the first
// picked series, "step" sums at the step, anything else sums from the first category.
export function readoutTotal(lookup, k, picked, mode, projection = null) {
  const real = (c, s) => lookup(c, s) ?? 0
  switch (mode) {
    case "value": return valueAtStep(lookup, k, picked[0], projection)
    case "step": return picked.reduce((sum, s) => sum + real(k, s), 0)
    default: {
      let sum = 0
      for (let c = 0; c <= k; c++) for (const s of picked) sum += real(c, s)
      return sum
    }
  }
}
